import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../Auth.css';
import logo from '../../../assets/images/seedxpert-light.png';
import { useTranslation } from 'react-i18next';

const EmailVerification = () => {
    const { t, i18n } = useTranslation();
    const { token } = useParams();
    const navigate = useNavigate();
    
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('');
    const [countdown, setCountdown] = useState(5);
    
    const verifyCalled = useRef(false);

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                const response = await axios.get(`/api/auth/verify-email/${token}`);
                
                if (response.data.language) {
                    await i18n.changeLanguage(response.data.language);
                }

                setStatus('success');
                
                setMessage(response.data.msg); 

            } catch (err) {
                setStatus('error');
                setMessage(err.response?.data?.msg || t('emailVerification.defaultError'));
            }
        };

        if (token && !verifyCalled.current) {
            verifyCalled.current = true;
            verifyEmail();
        }
    }, [token, i18n]); 

    useEffect(() => {
        if (status === 'success') {
            if (countdown > 0) {
                const timer = setTimeout(() => {
                    setCountdown((prev) => prev - 1);
                }, 1000);
                return () => clearTimeout(timer);
            } else {
                navigate('/');
            }
        }
    }, [status, countdown, navigate]);

    return (
        <div className="auth-container">
            <div className="bg-animation">
                <div className="floating-shape shape-1"></div>
                <div className="floating-shape shape-2"></div>
            </div>

             <div className="verification-box">
                <div className="logo-section">
                    <img src={logo} alt="SeedXpert" className="auth-logo" />
                </div>
                
                {status === 'verifying' && (
                    <div className="status-message">
                        <h2>{t('emailVerification.processing')}</h2>
                        <p>{t('emailVerification.verifyingMsg')}</p>
                    </div>
                )}

                {status === 'success' && (
                    <div className="status-message success">
                        <h2>🎉 {t('emailVerification.successTitle')}</h2>
                        <p>{message}</p>
                        <p className="redirect-text">
                            {t('emailVerification.redirectMsg', { count: countdown })}
                        </p>
                    </div>
                )}

                {status === 'error' && (
                    <div className="status-message error">
                        <h2>⚠️ {t('emailVerification.errorTitle')}</h2>
                        <p>{message}</p>
                        <button onClick={() => navigate('/')} className="auth-btn primary-btn">
                            {t('emailVerification.backButton')}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EmailVerification;